<template>
  <div class="showImgList">
    <div class="btns">
      <van-button type="default" size="small" @click="clear">取消</van-button>
      <van-button type="info" size="small" @click="clear">确定</van-button>
    </div>
    <div class="materiallist" id="materiallist">
      <div class="unify">
        <span>统一切换时间</span>
        <div>
          <van-stepper :disabled="!checked" v-model="unifyTime" @change="unify"/>
        </div>
        <div>
          <van-switch inactive-color="#ee0a24" v-model="checked" size="24px"/>
        </div>
      </div>

      <div class="materia-item" v-for="(item,index) in lists" :key="index">
        <div class="dele" :style="{
				height:height + 'px',
				width:height + 'px',
			}">
          <i class="etv etvicon etv-shanchu" @click="dele(index)"></i>
        </div>
        <img :src="upFileUrl + item.viewUrl" class="image" :style="{
				height:height + 'px',
				width:height + 'px',
			}">
        <div style="display: flex;flex-direction: column;justify-content: space-evenly" :style="{
				height:height + 'px',
			}">
          <div>音量</div>
          <van-stepper v-model="item.volume"/>
        </div>

      </div>
      <div class="photo" :style="{
							height:height + 'px',
							width: height + 'px'
						}">
        <div class="updata-centnt" @touchstart="showAddImg">
          <div class="updata">
            <div class="updata-img">
              <img src="/static/images/updata.png" style="width: 100%;height: 100%;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <addVideos v-if="isImg" @setVideos="setVideos" @close="close"></addVideos>
  </div>
</template>

<script>
  import addVideos from './addvideos'
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'showImgList',
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        height: 0,
        isImg: false,
        unifyTime: 70,
        checked: false,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.height = document.getElementById('materiallist').clientWidth / 4 - 1
      })
    },
    methods: {
      ...mapActions(['addVideos']),
      dele(index) {
        this.$emit('ondele', index)
      },
      showAddImg() {
        this.isImg = true
      },
      setVideos(data) {
        this.addVideos(data)
        this.isImg = false
      },
      close() {
        this.isImg = false
      },
      clear() {
        this.$emit('clear')
      },
      unify(val) {
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.volume = val
        })
      }
    },
    components: {
      addVideos,
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style scoped lang="scss">
  @import "../../public/static/css/app";

  .showImgList {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 55;
    background: #f1f1f1;

    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      border-bottom: 1px solid $uni-border-bottom-color;
    }

    .materiallist {
      width: 100%;
      padding: 2px;
      box-sizing: border-box;
      position: absolute;
      overflow: auto;
      top: 46px;
      left: 0;
      bottom: 0;
      height: calc(100% - 46px);

      .unify {
        display: flex;
        padding: 5px;
        justify-content: space-between;
        background: #ffffff;
        margin: 5px;

        & > span {

        }
      }

      .photo {
        box-sizing: border-box;
        padding: 5px;

        .updata-centnt {
          width: 100%;
          height: 100%;
          border-radius: 5px;

          .updata {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            background: #ffffff;

            .updata-img {
              width: 40%;
              height: 40%;
              margin-bottom: 10px;
            }
          }
        }
      }

      .materia-item {
        position: relative;
        margin: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        background: #FFFFFF;

        .dele {
          position: absolute;
          top: 2px;
          bottom: 2px;
          left: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: $uni-text-color-inverse;

          .etv-shanchu {
            font-size: 35px;
          }
        }

        .image {
          height: 100%;
          margin-right: 40px;
        }
      }
    }

  }
</style>
